import FormattingTooltipItem from './FormattingTooltipItem';
export default FormattingTooltipItem;
